import { joinBySymbol } from '@/helpers/filters'

export const defaultFilters = {
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    dateFrom: '',
    dateTo: '',
    orderPriceFrom: '',
    orderPriceTo: '',
    ids: '',
    cpaId: '',
    prepayment: '',
    search: '',
    historyDateFrom: '',
    historyDateTo: '',
    userGroup: [],
    operators: [],
    countries: [],
    regions: [],
    districts: [],
    cities: [],
    products: [],
    offerGroups: [],
    offers: [],
    salesTypes: [],
    niches: [],
    webId: [],
    attributes: [],
    callbackReasons: [],
    status: [],
    historyStatus: [],
    landings: [],
    tags: [],
    warehouses: [],
    deliveryServices: [],
    statusReasons: [],
    callbackCounts: [],
    historySubstatus: [],
  },
  sortBy: ['id'],
  sortDesc: [true],
  clientOptions: {
    filterPanelExpanded: false,
    selectedColumns: [],
  },
}

export function prepareOrderReportFilters(filter) {
  const filters = {}
  filters.countries = [...joinBySymbol(filter.countries).split('|')]
  filters.regions = [...joinBySymbol(filter.regions).split('|')]
  filters.districts = [...joinBySymbol(filter.districts).split('|')]
  filters.cities = [...joinBySymbol(filter.cities).split('|')]
  return filters
}
